import {versaoGitFiltrada} from 'src/utils'

let backUrl
let reppUrl
let gerenciadorUrl

if (process.env.VUE_APP_K8s) {
  let namespace = window.location.pathname
  namespace = namespace[namespace.length - 1] === '/' ? namespace.slice(0, namespace.length - 1) : namespace
  namespace = namespace.split('/bateponto')[0]
  backUrl = `${window.location.origin}${namespace}`  + '/back'
  reppUrl = `${window.location.origin}${namespace}`  + '/rep-p'
  gerenciadorUrl = `${window.location.origin}${namespace}`  + '/gerenciador-de-coletores'
} else {
  backUrl = `${process.env.VUE_APP_API_URL}`
  reppUrl = `${process.env.VUE_APP_REPP_URL}`
  gerenciadorUrl = `${process.env.VUE_APP_GERENCIADOR_URL}`
}

const recaptchaToken = process.env.VUE_APP_RECAPTCHA_PUBLIC_TOKEN
const versao = versaoGitFiltrada(process.env.VUE_APP_TAG_VERSION)

const config = {
  backUrl,
  reppUrl,
  gerenciadorUrl,
  herokuUrl: `${process.env.VUE_APP_HEROKU_URL}`,
  newHerokuUrl: `${process.env.VUE_APP_NEW_HEROKU_URL}`,
  version: versao,
  recaptchaToken
}

export default config
